import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_PARK_DASHBOARD_REQUEST = "FETCH_PARK_DASHBOARD_REQUEST";
export const FETCH_PARK_DASHBOARD_SUCCESS = "FETCH_PARK_DASHBOARD_SUCCESS";
export const FETCH_PARK_DASHBOARD_FAILURE = "FETCH_PARK_DASHBOARD_FAILURE";

export const FETCH_ATTENDANCE_TREND_REQUEST = "FETCH_ATTENDANCE_TREND_REQUEST";
export const FETCH_ATTENDANCE_TREND_SUCCESS = "FETCH_ATTENDANCE_TREND_SUCCESS";
export const FETCH_ATTENDANCE_TREND_FAILURE = "FETCH_ATTENDANCE_TREND_FAILURE";

export const FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST = "FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST";
export const FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS = "FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS";
export const FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE = "FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE";

export const FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST = "FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST";
export const FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS = "FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS";
export const FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE = "FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE";

// ───────────────
// Action Creators
// ───────────────

// export const fetchParkDashboard = () => async (dispatch) => {
//   dispatch({ type: FETCH_PARK_DASHBOARD_REQUEST });
//   const token = localStorage.getItem("token");

//   try {
//     const res = await axios.get(`${BASE_URL}/v1/api/parkDashboard`, {
//       headers: { authorization: token },
//     });
//     dispatch({
//       type: FETCH_PARK_DASHBOARD_SUCCESS,
//       payload: res.data.data || {},
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_PARK_DASHBOARD_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
//   }
// };

// export const fetchAttendanceTrend = () => async (dispatch) => {
//   dispatch({ type: FETCH_ATTENDANCE_TREND_REQUEST });
//   const token = localStorage.getItem("token");

//   try {
//     const res = await axios.get(`${BASE_URL}/v1/api/attendanceTrend`, {
//       headers: { authorization: token },
//     });
//     dispatch({
//       type: FETCH_ATTENDANCE_TREND_SUCCESS,
//       payload: res.data.data?.attendanceTrend || [],
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ATTENDANCE_TREND_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
//   }
// };

// export const fetchDailyAttendanceOverview = (date) => async (dispatch) => {
//   dispatch({ type: FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST });
//   const token = localStorage.getItem("token");

//   try {
//     const res = await axios.get(
//       `${BASE_URL}/v1/api/dailyAttendanceOverview?date=${date}`,
//       { headers: { authorization: token } }
//     );
//     dispatch({
//       type: FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS,
//       payload: res.data.data || [],
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
//   }
// };

// export const fetchUserDistributionByDistrict = () => async (dispatch) => {
//   dispatch({ type: FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST });
//   const token = localStorage.getItem("token");

//   try {
//     const res = await axios.get(`${BASE_URL}/v1/api/userDistributionByDistrict`, {
//       headers: { authorization: token },
//     });
//     dispatch({
//       type: FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS,
//       payload: res.data.data?.districtUsers || [],
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
//   }
// };


// actions/dashboardParkActions.js (already good, just confirm payload)
export const fetchParkDashboard = () => async (dispatch) => {
  dispatch({ type: FETCH_PARK_DASHBOARD_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(`${BASE_URL}/v1/api/parkDashboard`, {
      headers: { authorization: token },
    });
    dispatch({
      type: FETCH_PARK_DASHBOARD_SUCCESS,
      payload: res.data.data, // { total_users, today_checkins, ... }
    });
  } catch (error) {
    dispatch({
      type: FETCH_PARK_DASHBOARD_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const fetchAttendanceTrend = () => async (dispatch) => {
  dispatch({ type: FETCH_ATTENDANCE_TREND_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(`${BASE_URL}/v1/api/attendanceTrend`, {
      headers: { authorization: token },
    });
    dispatch({
      type: FETCH_ATTENDANCE_TREND_SUCCESS,
      payload: res.data.data.attendanceTrend || [],
    });
  } catch (error) {
    dispatch({
      type: FETCH_ATTENDANCE_TREND_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const fetchDailyAttendanceOverview = (date) => async (dispatch) => {
  dispatch({ type: FETCH_DAILY_ATTENDANCE_OVERVIEW_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(
      `${BASE_URL}/v1/api/dailyAttendanceOverview?date=${date}`,
      { headers: { authorization: token } }
    );
    dispatch({
      type: FETCH_DAILY_ATTENDANCE_OVERVIEW_SUCCESS,
      payload: res.data.data || [],
    });
  } catch (error) {
    dispatch({
      type: FETCH_DAILY_ATTENDANCE_OVERVIEW_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const fetchUserDistributionByDistrict = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_DISTRIBUTION_DISTRICT_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(`${BASE_URL}/v1/api/userDistributionByDistrict`, {
      headers: { authorization: token },
    });
    dispatch({
      type: FETCH_USER_DISTRIBUTION_DISTRICT_SUCCESS,
      payload: res.data.data.districtUsers || [],
    });
  } catch (error) {
    dispatch({
      type: FETCH_USER_DISTRIBUTION_DISTRICT_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};